import { RouteRecordRaw } from 'vue-router';

export const routes: Array<RouteRecordRaw> = [
  {
    path: 'site-company/',
    name: 'SiteCompany',
    component: () => import('~/views/siteCompany/SiteCompany.vue'),
    meta: {
      title: 'Сайт компании ЖКХ'
    }
  },
  // {START} lists
  {
    path: 'site-company/site-settings',
    name: 'SiteSettings',
    component: () => import('~/views/siteCompany/list-items/SiteSettings.vue'),
    meta: {
      title: 'Общие настройки'
    }
  },
  {
    path: 'site-company/site-settings/support-settings-change-log',
    name: 'SiteCompany.SupportSettingsChangeLog',
    component: () => import('~/views/siteCompany/lists/SupportSettingsChangeLog.vue'),
    meta: {
      title: 'Логи изменений'
    }
  },
  {
    path: 'site-company/additional-options',
    name: 'AdditionalOptions',
    component: () => import('~/views/siteCompany/lists/AdditionalOptions.vue'),
    meta: {
      title: 'Дополнительные параметры'
    }
  },
  {
    path: 'site-company/additional-options/detail/:id?',
    name: 'AdditionalOption',
    component: () => import('~/views/siteCompany/list-items/AdditionalOption.vue'),
    meta: {
      title: 'Дополнительный параметр'
    }
  },
  {
    path: 'site-company/site-partner-links',
    name: 'SitePartnerLinks',
    component: () => import('~/views/siteCompany/lists/SitePartnerLinks.vue'),
    meta: {
      title: 'Партнерские ссылки на сайте'
    }
  },
  {
    path: 'site-company/site-partner-links/detail/:id?',
    name: 'SitePartnerLink',
    component: () => import('~/views/siteCompany/list-items/SitePartnerLink.vue'),
    meta: {
      title: 'Партнерская ссылка на сайте'
    }
  },
  {
    path: 'site-company/news',
    name: 'News',
    component: () => import('~/views/siteCompany/lists/News.vue'),
    meta: {
      title: 'Новости'
    }
  },
  {
    path: 'site-company/news/detail/:id?',
    name: 'NewsDetails',
    component: () => import('~/views/siteCompany/list-items/NewsDetails.vue'),
    meta: {
      title: 'Новость'
    }
  },

  // notification channels
  {
    path: 'site-company/notification-channels',
    name: 'NotificationChannels',
    component: () => import('~/views/siteCompany/lists/NotificationChannels.vue'),
    meta: {
      title: 'Каналы уведомлений'
    }
  },
  {
    path: 'site-company/notification-channels/detail/:id?',
    name: 'NotificationChannelDetail',
    component: () => import('~/views/siteCompany/list-items/NotificationChannelDetail.vue'),
    meta: {
      title: 'Канал уведомлений'
    }
  },

  {
    path: 'site-company/faq',
    name: 'FAQ',
    component: () => import('~/views/siteCompany/lists/FAQ.vue'),
    meta: {
      title: 'Частые вопросы и ответы'
    }
  },
  {
    path: 'site-company/faq/detail/:id?',
    name: 'FAQDetails',
    component: () => import('~/views/siteCompany/list-items/FAQDetail.vue'),
    meta: {
      title: 'Частый вопрос и ответ'
    }
  },
  {
    path: 'site-company/documents',
    name: 'Documents',
    component: () => import('~/views/siteCompany/lists/Documents.vue'),
    meta: {
      title: 'Документы'
    }
  },
  {
    path: 'site-company/documents/detail/:id?',
    name: 'Document',
    component: () => import('~/views/siteCompany/list-items/DocumentDetails.vue'),
    meta: {
      title: 'Документ'
    }
  },
  {
    path: 'site-company/document-groups',
    name: 'DocumentGroups',
    component: () => import('~/views/siteCompany/lists/DocumentGroups.vue'),
    meta: {
      title: 'Группы Документов'
    }
  },
  {
    path: 'site-company/document-groups/detail/:id?',
    name: 'DocumentGroupe',
    component: () => import('~/views/siteCompany/list-items/DocumentGroupe.vue'),
    meta: {
      title: 'Группа Документов'
    }
  },
  {
    path: 'site-company/articles',
    name: 'Articles',
    component: () => import('~/views/siteCompany/lists/Articles.vue'),
    meta: {
      title: 'Статьи'
    }
  },
  {
    path: 'site-company/articles/detail/:id?',
    name: 'ArticleDetails',
    component: () => import('~/views/siteCompany/list-items/ArticleDetails.vue'),
    meta: {
      title: 'Статья'
    }
  },
  {
    path: 'site-company/photo-reports',
    name: 'PhotoReports',
    component: () => import('~/views/siteCompany/lists/PhotoReports.vue'),
    meta: {
      title: 'Фотоотчеты'
    }
  },
  {
    path: 'site-company/photo-reports/detail/:id?',
    name: 'PhotoReport',
    component: () => import('~/views/siteCompany/list-items/PhotoReport.vue'),
    meta: {
      title: 'Фотоотчет'
    }
  },
  {
    path: 'site-company/files',
    name: 'Files',
    component: () => import('~/views/siteCompany/lists/Files.vue'),
    meta: {
      title: 'Файлы'
    }
  },
  {
    path: 'site-company/files/detail/:id?',
    name: 'FileDetails',
    component: () => import('~/views/siteCompany/list-items/FileDetails.vue'),
    meta: {
      title: 'Файл'
    }
  },
  {
    path: 'site-company/files/folders/detail/:id?',
    name: 'FileFolders',
    component: () => import('~/views/siteCompany/list-items/FileFolders.vue'),
    meta: {
      title: 'Папка'
    }
  },
  {
    path: 'site-company/about-company/:id',
    name: 'AboutCompany',
    component: () => import('~/views/siteCompany/list-items/AboutCompany.vue'),
    meta: {
      title: 'О компании'
    }
  },
  {
    path: 'site-company/houses',
    name: 'SiteCompany.Houses',
    component: () => import('~/views/siteCompany/lists/Houses.vue'),
    meta: {
      title: 'Дома'
    }
  },
  {
    path: 'site-company/houses/detail/:id?',
    name: 'SiteCompany.House',
    component: () => import('~/views/siteCompany/list-items/SiteCompanyHouse.vue'),
    meta: {
      title: 'Дом'
    }
  },
  {
    path: 'site-company/gallery-albums',
    name: 'GalleryAlbums',
    component: () => import('~/views/siteCompany/lists/GalleryAlbums.vue'),
    meta: {
      title: 'Альбомы'
    }
  },
  {
    path: 'site-company/gallery-albums/detail/:id?',
    name: 'GalleryAlbum',
    component: () => import('~/views/siteCompany/list-items/GalleryAlbum.vue'),
    meta: {
      title: 'Альбом'
    }
  },
  {
    path: 'site-company/gallery-images',
    name: 'GalleryImages',
    component: () => import('~/views/siteCompany/lists/GalleryImages.vue'),
    meta: {
      title: 'Изображения'
    }
  },
  {
    path: 'site-company/gallery-images/detail/:id?',
    name: 'GalleryImage',
    component: () => import('~/views/siteCompany/list-items/GalleryImage.vue'),
    meta: {
      title: 'Изображение'
    }
  },
  {
    path: 'site-company/gallery-videos',
    name: 'GalleryVideos',
    component: () => import('~/views/siteCompany/lists/GalleryVideos.vue'),
    meta: {
      title: 'Видео'
    }
  },
  {
    path: 'site-company/gallery-videos/detail/:id?',
    name: 'GalleryVideo',
    component: () => import('~/views/siteCompany/list-items/GalleryVideo.vue'),
    meta: {
      title: 'Настройка Видео'
    }
  },
  {
    path: 'site-company/site-menu-items',
    name: 'SiteMenuItems',
    component: () => import('~/views/siteCompany/lists/SiteMenuItems.vue'),
    meta: {
      title: 'Меню'
    }
  },
  {
    path: 'site-company/site-menu-items/detail/:id?',
    name: 'SiteMenuItem',
    component: () => import('~/views/siteCompany/list-items/SiteMenuItem.vue'),
    meta: {
      title: 'Пункт Меню'
    }
  },
  // {END} lists
  // {START} long-process
  {
    path: 'site-company/export-houses-to-excel-processor',
    name: 'SiteCompany.ExportHousesToExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesToExcelProcessor.vue'),
    meta: {
      title: 'Выгрузить доп. информацию по домам (XLSX)'
    }
  },
  {
    path: 'site-company/export-houses-without-fias-processor',
    name: 'SiteCompany.ExportHousesWithoutFiasProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ExportHousesWithoutFiasProcessor.vue'),
    meta: {
      title: 'Выгрузить дома без ФИАС в CSV файл'
    }
  },
  {
    path: 'site-company/house-creation-master-processor',
    name: 'SiteCompany.HouseCreationMasterProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseCreationMasterProcessor.vue'),
    meta: {
      title: 'Мастер создания дома'
    }
  },
  {
    path: 'site-company/house-fiases-processor',
    name: 'SiteCompany.HouseFiasesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseFiasesProcessor.vue'),
    meta: {
      title: 'Загрузить ФИАСы'
    }
  },
  {
    path: 'site-company/houses-for-tko-contract-processor',
    name: 'SiteCompany.HousesForTkoContractProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HousesForTkoContractProcessor.vue'),
    meta: {
      title: 'Заполнить шаблон по добавлению ОЖФ в договор ТКО(XLSX)'
    }
  },
  {
    path: 'site-company/house-type-by-premise-type-processor',
    name: 'SiteCompany.HouseTypeByPremiseTypeProcessor',
    component: () => import('~/views/electronic-control-room/long-process/HouseTypeByPremiseTypeProcessor.vue'),
    meta: {
      title: 'Изменение типа домов по кол-ву помещений'
    }
  },
  {
    path: 'site-company/import-houses-from-excel-processor',
    name: 'SiteCompany.ImportHousesFromExcelProcessor',
    component: () => import('~/views/electronic-control-room/long-process/ImportHousesFromExcelProcessor.vue'),
    meta: {
      title: 'Загрузить доп. информацию по домам (XLSX)'
    }
  },
  {
    path: 'site-company/premises-not-linked-to-account-remove-processor',
    name: 'SiteCompany.PremisesNotLinkedToAccountRemoveProcessor',
    component: () => import('~/views/electronic-control-room/long-process/PremisesNotLinkedToAccountRemoveProcessor.vue'),
    meta: {
      title: 'Удалить помещения, не привязанные к ЛС'
    }
  },
  {
    path: 'site-company/update-houses-addresses-processor',
    name: 'SiteCompany.UpdateHousesAddressesProcessor',
    component: () => import('~/views/electronic-control-room/long-process/UpdateHousesAddressesProcessor.vue'),
    meta: {
      title: 'Обновление адресов домов'
    }
  }
  // {END} long-process
];